var map = {
	"./Blood Pressure disabled.svg": 96438,
	"./Body Temp disabled.svg": 68573,
	"./Check.svg": 60977,
	"./Configurations.svg": 60950,
	"./Countries.svg": 69123,
	"./Edit.svg": 88767,
	"./Ellipse.svg": 75535,
	"./Expand.svg": 51695,
	"./Eye-hide.svg": 37163,
	"./Eye-show.svg": 12320,
	"./Flag.svg": 59881,
	"./Fota.svg": 87255,
	"./Glucose disabled.svg": 98787,
	"./Glucose.svg": 93233,
	"./Hide.svg": 4739,
	"./Home.svg": 98606,
	"./Inbox.svg": 72701,
	"./Next.svg": 82748,
	"./PDF.svg": 73571,
	"./PathEcg.svg": 8821,
	"./Patients.svg": 88625,
	"./Physicians.svg": 19156,
	"./Prev.svg": 25340,
	"./Pulse Rate disabled.svg": 51388,
	"./Reports.svg": 16612,
	"./Respiratory Rate disabled.svg": 54495,
	"./Respiratory Rate.svg": 62709,
	"./Search.svg": 80423,
	"./Show.svg": 47192,
	"./Sort.svg": 21655,
	"./SpO2 disabled.svg": 20775,
	"./SpO2.svg": 28877,
	"./Versions.svg": 11448,
	"./Viewers.svg": 57112,
	"./Weight disabled.svg": 78749,
	"./Weight.svg": 55551,
	"./af-report-icon.svg": 31813,
	"./af.svg": 66686,
	"./afDetected.svg": 31788,
	"./afNotDetected.svg": 35219,
	"./alerton.svg": 55712,
	"./annotations-report-icon.svg": 78592,
	"./app_disconnected.svg": 85630,
	"./arrow-down.svg": 13535,
	"./arrythmia-filter.svg": 77787,
	"./avatar.svg": 82784,
	"./bell.svg": 66876,
	"./blood-pressure-report-icon.svg": 65504,
	"./blood_pressure.svg": 85853,
	"./body_temp.svg": 41248,
	"./calander.svg": 78969,
	"./calories.svg": 36351,
	"./checkbox.svg": 32500,
	"./circle.svg": 72431,
	"./clock.svg": 96347,
	"./common/github.svg": 25614,
	"./common/google.svg": 65282,
	"./daily-report-icon.svg": 65701,
	"./events-report-icon.svg": 79007,
	"./generate-unique-id.svg": 61488,
	"./glucose.svg": 55537,
	"./grid-off.svg": 3999,
	"./grid.svg": 33735,
	"./hamburger.svg": 48780,
	"./home.svg": 23086,
	"./list-on.svg": 76467,
	"./list.svg": 68855,
	"./medcine_reminder.svg": 38029,
	"./messages.svg": 11899,
	"./monthly-report-icon.svg": 81317,
	"./my_profile.svg": 22167,
	"./night_respiratory.svg": 22578,
	"./night_rrv.svg": 14324,
	"./notMeasured.svg": 43942,
	"./offwrist.svg": 27587,
	"./patient_list.svg": 92717,
	"./patient_requests.svg": 26619,
	"./physicians.svg": 90580,
	"./pinnedoff.svg": 5944,
	"./pinnedon.svg": 13970,
	"./print.svg": 87196,
	"./pulse_rate.svg": 70735,
	"./pwv-report-icon.svg": 38089,
	"./reminder_clock.svg": 18814,
	"./remindmelater.svg": 77692,
	"./remove-doctor.svg": 21189,
	"./reports.svg": 4772,
	"./saturation-report-icon.svg": 20880,
	"./search-circle.svg": 20164,
	"./send-circle.svg": 51518,
	"./sleep-apnea-report-icon.svg": 40041,
	"./sleep.svg": 78004,
	"./sort.svg": 40631,
	"./sort_list.svg": 65006,
	"./spo2.svg": 98509,
	"./steps.svg": 41944,
	"./tike.svg": 60038,
	"./timefilter.svg": 26294,
	"./trash.svg": 82571,
	"./vi.svg": 26020,
	"./watch_diconnected.svg": 32339,
	"./watches.svg": 26280,
	"./weight.svg": 27263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57521;